// import React from "react";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/ContactPage.css";

// const conOfficeInfo = {
//   address:
//     "Office #1401, S.No. 30, DNK SQUARE, Airport Road, Sakore Nagar, Viman Nagar, Pune - 411014",

//   region: "Maharashtra, India",

//   embedUrl:
//     "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.316819323363!2d73.90418237519266!3d18.557674182544327!2m3!1f0!2f0!3f0!3m2!1i1024!2i1024!4f13.1!3m3!1m2!1s0x3bc2c127fe3f730b%3A0x7fbe51543d7f950a!2sDNK%20SQUARE%20by%20Dugad%20Group!5e0!3m2!1sen!2sin!4v1709756100000!5m2!1sen!2sin",

//   mapUrl:
//     "https://www.google.com/maps?q=DNK+SQUARE+Viman+Nagar+Pune",
// };

// const ContactPage = () => {
//   return (

//     <div className="con-page-wrapper">

//       <Navbar />

//       {/* HERO */}

//       <section id="contact" className="con-hero-section">

//         <p className="con-mini-title">
//           CONTACT OUR TEAM
//         </p>

//         <h1 className="con-main-title">
//           Let’s Build Smarter <br />
//           Workforce Solutions Together
//         </h1>

//         <p className="con-description">
//           Connect with our team for enterprise HRMS solutions,
//           software demonstrations, implementation support,
//           and business inquiries.
//         </p>

//       </section>

//       {/* CONTACT CARDS */}

//       <section className="con-cards-section">

//         <div className="con-card">

//           <span>📧</span>

//           <h3>Email</h3>

//           <p>contact@genesistech.co.in</p>

//         </div>

//         <div className="con-card">

//           <span>📞</span>

//           <h3>Phone</h3>

//           <p>+91 98765 43210</p>

//         </div>

//         <div className="con-card">

//           <span>📍</span>

//           <h3>Office</h3>

//           <p>{conOfficeInfo.region}</p>

//         </div>

//       </section>

//       {/* FORM SECTION */}

//       <section className="con-form-section">

//         {/* LEFT */}

//         <div className="con-form-left">

//           <p className="con-form-tag">
//             REQUEST A DEMO
//           </p>

//           <h2>
//             Talk to Our <br />
//             Enterprise Team
//           </h2>

//           <p>
//             Learn how Genesis HRMS can simplify
//             attendance, payroll, employee workflows,
//             and enterprise operations.
//           </p>

//           <div className="con-info-list">

//             <div className="con-info-item">
//               ✓ Enterprise-grade HRMS Platform
//             </div>

//             <div className="con-info-item">
//               ✓ Workforce Automation
//             </div>

//             <div className="con-info-item">
//               ✓ Cloud & Secure Infrastructure
//             </div>

//             <div className="con-info-item">
//               ✓ Dedicated Support Team
//             </div>

//           </div>

//         </div>

//         {/* RIGHT */}

//         <div className="con-form-right">

//           <form className="con-demo-form">

//             <div className="con-form-grid">

//               <input
//                 type="text"
//                 placeholder="Full Name"
//               />

//               <input
//                 type="email"
//                 placeholder="Business Email"
//               />

//               <input
//                 type="text"
//                 placeholder="Company Name"
//               />

//               <input
//                 type="text"
//                 placeholder="Phone Number"
//               />

//             </div>

//             <textarea
//               placeholder="Tell us about your requirements..."
//             ></textarea>

//             <button type="submit">
//               Request Demo
//             </button>

//           </form>

//         </div>

//       </section>

//       {/* MAP */}

//       <section className="con-map-section">

//         <div className="con-map-card">

//           <h2>
//             Visit Our Office
//           </h2>

//           <p className="con-office-address">
//             {conOfficeInfo.address}
//           </p>

//           <a
//             href={conOfficeInfo.mapUrl}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="con-map-button"
//           >
//             Open in Google Maps
//           </a>

//           <div className="con-map-frame-wrapper">

//             <iframe
//               src={conOfficeInfo.embedUrl}
//               width="100%"
//               height="450"
//               style={{
//                 border: 0,
//                 borderRadius: "24px",
//               }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               title="Genesis Tech Engineers Location"
//             ></iframe>

//           </div>

//         </div>

//       </section>

//       <Footer />

//     </div>

//   );
// };

// export default ContactPage;



















// import React, { useState } from "react";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/ContactPage.css";
// const conOfficeInfo = {
//   address:
//     "1401, 1406 – Genesis Tech Engineers Pvt. Ltd., DNK Square, Airport Road, Vimannagar, Pune, MH, INDIA 411014",

//   region: "Maharashtra, India",

//   embedUrl:
//     "https://maps.google.com/maps?q=18.557674,73.906758&z=17&output=embed",

//   mapUrl:
//     "https://www.google.com/maps/search/?api=1&query=18.557674,73.906758",
// };
// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     full_name: "",
//     business_email: "",
//     company_name: "",
//     phone_number: "",
//     requirements: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setLoading(true);

//     try {
//       const response = await fetch("/gt-api/contact_form.php", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert(" request submitted successfully!");

//         setFormData({
//           full_name: "",
//           business_email: "",
//           company_name: "",
//           phone_number: "",
//           requirements: "",
//         });
//       } else {
//         alert(result.message);
//       }
//     } catch (error) {
//       alert("Something went wrong");
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="con-page-wrapper">
//       <Navbar />

//       {/* HERO */}

//       <section id="contact" className="con-hero-section">
//         <p className="con-mini-title">
//           CONTACT OUR TEAM
//         </p>

//         <h1 className="con-main-title">
//           Let’s Build Smarter <br />
//           Workforce Solutions Together
//         </h1>

//         <p className="con-description">
//           Connect with our team for enterprise HRMS solutions,
//           software demonstrations, implementation support,
//           and business inquiries.
//         </p>
//       </section>

//       {/* CONTACT CARDS */}

//       <section className="con-cards-section">
//         <div className="con-card">
//           <span>📧</span>

//           <h3>Email</h3>

//           <p>contact@genesistech.co.in</p>
//         </div>

//         <div className="con-card">
//           <span>📞</span>

//           <h3>Phone</h3>

//           <p>+91 7841063605</p>
//         </div>

//         <div className="con-card">
//           <span>📍</span>

//           <h3>Office</h3>

//           <p>1401, 1406 – Genesis Tech Engineers Pvt. Ltd., DNK Square, Airport Road, Vimannagar, Pune, MH, INDIA 411014</p>
//         </div>
//       </section>

//       {/* FORM SECTION */}

//       <section className="con-form-section">
//         {/* LEFT */}

//         <div className="con-form-left">
//           <p className="con-form-tag">
//             CONTACT US
//           </p>

//           <h2>
//             Talk to Our <br />
//             Enterprise Team
//           </h2>

//           <p>
//             Learn how Genesis HRMS can simplify
//             attendance, payroll, employee workflows,
//             and enterprise operations.
//           </p>

//           <div className="con-info-list">
//             <div className="con-info-item">
//               ✓ Enterprise-grade HRMS Platform
//             </div>

//             <div className="con-info-item">
//               ✓ Workforce Automation
//             </div>

//             <div className="con-info-item">
//               ✓ Cloud & Secure Infrastructure
//             </div>

//             <div className="con-info-item">
//               ✓ Dedicated Support Team
//             </div>
//           </div>
//         </div>

//         {/* RIGHT */}

//         <div className="con-form-right">
//           <form className="con-demo-form" onSubmit={handleSubmit}>
//             <div className="con-form-grid">
//               <input
//                 type="text"
//                 name="full_name"
//                 placeholder="Full Name"
//                 value={formData.full_name}
//                 onChange={handleChange}
//                 required
//               />

//               <input
//                 type="email"
//                 name="business_email"
//                 placeholder="Business Email"
//                 value={formData.business_email}
//                 onChange={handleChange}
//                 required
//               />

//               <input
//                 type="text"
//                 name="company_name"
//                 placeholder="Company Name"
//                 value={formData.company_name}
//                 onChange={handleChange}
//                 required
//               />

//               <input
//                 type="text"
//                 name="phone_number"
//                 placeholder="Phone Number"
//                 value={formData.phone_number}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <textarea
//               name="requirements"
//               placeholder="Tell us about your requirements..."
//               value={formData.requirements}
//               onChange={handleChange}
//             ></textarea>

//             <button type="submit" disabled={loading}>
//               {loading ? "Submitting..." : "SUBMIT"}
//             </button>
//           </form>
//         </div>
//       </section>

//       {/* MAP */}

//       <section className="con-map-section">
//         <div className="con-map-card">
//           <h2>
//             Visit Our Office
//           </h2>

//           <p className="con-office-address">
//             {conOfficeInfo.address}
//           </p>

//           <a
//             href={conOfficeInfo.mapUrl}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="con-map-button"
//           >
//             Open in Google Maps
//           </a>

//           <div className="con-map-frame-wrapper">
//             <iframe
//               src={conOfficeInfo.embedUrl}
//               width="100%"
//               height="450"
//               style={{
//                 border: 0,
//                 borderRadius: "24px",
//               }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               title="Genesis Tech Engineers Location"
//             ></iframe>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default ContactPage;



















import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ContactSection from "./ContactSection";
import "./styles/ContactPage.css";

const ContactPage = () => {
  return (
    <div className="con-page-wrapper">
      <Navbar />

      {/* HERO */}
      <section id="contact" className="con-hero-section">
        <p className="con-mini-title">CONTACT OUR TEAM</p>

        <h1 className="con-main-title">
          Let’s Build Smarter <br />
          Solutions Together
        </h1>

        <p className="con-description">
          Connect with our team for enterprise software solutions,
          software demonstrations, implementation support,
          and business inquiries.
        </p>
      </section>

      {/* REUSABLE CONTACT CARDS, FORM & MAP */}
      <ContactSection />

      <Footer />
    </div>
  );
};

export default ContactPage;